import { Checkbox, FormControlLabel, IconButton, Modal, Stack, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { useDispatch, useSelector } from 'react-redux';
import { TableHeader } from '../../app/AppStyles';
import { SearchKeyFilter } from '../../app/AppUtils';
import ContentLoader from '../subcomponents/ContentLoader';
import FilterButton from '../subcomponents/FilterButton';
import FilterSidebar from '../subcomponents/FilterSidebar';
import PageLayout from '../subcomponents/PageLayout';
import TablePaginationActions from '../subcomponents/TablePaginationActions';
import EmployeeEditCard from './EmployeeEditCard';
import EmployeeLinkCard from './EmployeeLinkCard';
import { fetchEmployees } from './employeeSlice';

import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from '@mui/icons-material/Link';

export default function EmployeePage() {
    const dispatch = useDispatch();

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { employees } = useSelector((state) => state.employees);
    const { aspNetUser } = useSelector((state) => state.settings.app);

    const [filter, setFilter] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [openEdit, setOpenEdit] = useState(false);
    const [openLink, setOpenLink] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);

    const [hasActivities, setHasActivities] = useState(false);
    const [hasTimetables, setHasTimetables] = useState(false);
    const [hasEmployees, setHasEmployees] = useState(false);
    const [hasOrganisation, setHasOrganisation] = useState(false);
    const [hasPrograms, setHasPrograms] = useState(false);
    const [hasWebmaster, setHasWebmaster] = useState(false);

    const [hasSubscriptions, setHasSubscriptions] = useState(false);
    const [hasMessages, setHasMessages] = useState(false);
    const [hasPlanning, setHasPlanning] = useState(false);
    const [hasAttendances, setHasAttendances] = useState(false);
    const [hasReports, setHasReports] = useState(false);
    const [hasStudents, setHasStudents] = useState(false);
    const [hasSupervisor, setHasSupervisor] = useState(false);

    const [isContact, setIsContact] = useState(false);
    const [isTestUser, setIsTestUser] = useState(false);

    const [hasAdmin, setHasAdmin] = useState(false);
    const [hasSysadmin, setHasSysadmin] = useState(false);

    useEffect(() => {
        dispatch(fetchEmployees(isActive));
    }, [dispatch, isActive]);

    const callbackModalEdit = () => {
        setOpenEdit(false);
        setSelectedEmployee(null);
        dispatch(fetchEmployees(isActive));
    };

    const callbackModalLink = () => {
        setOpenLink(false);
        setSelectedEmployee(null);
        dispatch(fetchEmployees(isActive));
    };

    const handleFilterResult = (item) => {
        return SearchKeyFilter(item, ["fullname", "number"], filter) &&
            (!hasActivities || item.activities) &&
            (!hasTimetables || item.timetables) &&
            (!hasEmployees || item.employees) &&
            (!hasOrganisation || item.organisation) &&
            (!hasPrograms || item.programs) &&
            (!hasWebmaster || item.webmaster) &&

            (!hasSubscriptions || item.subscriptions) &&
            (!hasMessages || item.messages) &&
            (!hasPlanning || item.planning) &&
            (!hasAttendances || item.attendances) &&
            (!hasReports || item.reports) &&
            (!hasStudents || item.students) &&
            (!hasSupervisor || item.supervisor) &&

            (!isContact || item.contactPerson) &&
            (!isTestUser || item.isTestUser) &&

            (!hasAdmin || item.admin) &&
            (!hasSysadmin || item.sysadmin);
    }

    const FilterFragment = () => {
        return (
            <Stack>
                <FormControlLabel control={<Checkbox checked={isActive} onChange={() => setIsActive(!isActive)} />} label={`${resourceFinal[appLanguage].words.ACTIVE}`} />
                <Typography variant="subtitle2" color="primary">{resourceFinal[appLanguage].words.MANAGEMENT}</Typography>
                <FormControlLabel control={<Checkbox checked={hasActivities} onChange={() => setHasActivities(!hasActivities)} />} label={`${resourceFinal[appLanguage].words.ROLE_ACTIVITIES}`} />
                <FormControlLabel control={<Checkbox checked={hasTimetables} onChange={() => setHasTimetables(!hasTimetables)} />} label={`${resourceFinal[appLanguage].words.ROLE_TIMETABLES}`} />
                <FormControlLabel control={<Checkbox checked={hasEmployees} onChange={() => setHasEmployees(!hasEmployees)} />} label={`${resourceFinal[appLanguage].words.ROLE_EMPLOYEES}`} />
                <FormControlLabel control={<Checkbox checked={hasOrganisation} onChange={() => setHasOrganisation(!hasOrganisation)} />} label={`${resourceFinal[appLanguage].words.ROLE_ORGANISATION}`} />
                <FormControlLabel control={<Checkbox checked={hasPrograms} onChange={() => setHasPrograms(!hasPrograms)} />} label={`${resourceFinal[appLanguage].words.ROLE_PROGRAMS}`} />
                <FormControlLabel control={<Checkbox checked={hasWebmaster} onChange={() => setHasWebmaster(!hasWebmaster)} />} label={`${resourceFinal[appLanguage].words.ROLE_WEBMASTER}`} />
                <Typography variant="subtitle2" color="primary">{resourceFinal[appLanguage].words.QUALIFICATIONS}</Typography>
                <FormControlLabel control={<Checkbox checked={hasSubscriptions} onChange={() => setHasSubscriptions(!hasSubscriptions)} />} label={`${resourceFinal[appLanguage].words.ROLE_SUBSCRIPTIONS}`} />
                <FormControlLabel control={<Checkbox checked={hasMessages} onChange={() => setHasMessages(!hasMessages)} />} label={`${resourceFinal[appLanguage].words.ROLE_MESSAGES}`} />
                <FormControlLabel control={<Checkbox checked={hasPlanning} onChange={() => setHasPlanning(!hasPlanning)} />} label={`${resourceFinal[appLanguage].words.ROLE_PLANNING}`} />
                <FormControlLabel control={<Checkbox checked={hasAttendances} onChange={() => setHasAttendances(!hasAttendances)} />} label={`${resourceFinal[appLanguage].words.ROLE_ATTENDANCES}`} />
                <FormControlLabel control={<Checkbox checked={hasReports} onChange={() => setHasReports(!hasReports)} />} label={`${resourceFinal[appLanguage].words.ROLE_REPORTS}`} />
                <FormControlLabel control={<Checkbox checked={hasStudents} onChange={() => setHasStudents(!hasStudents)} />} label={`${resourceFinal[appLanguage].words.ROLE_STUDENTS}`} />
                <FormControlLabel control={<Checkbox checked={hasSupervisor} onChange={() => setHasSupervisor(!hasSupervisor)} />} label={`${resourceFinal[appLanguage].words.ROLE_SUPERVISOR}`} />
                <Typography variant="subtitle2" color="primary">{resourceFinal[appLanguage].words.OTHERS}</Typography>
                <FormControlLabel control={<Checkbox checked={isContact} onChange={() => setIsContact(!isContact)} />} label={`${resourceFinal[appLanguage].words.CONTACTPERSON}`} />
                <Typography variant="subtitle2" color="primary">{resourceFinal[appLanguage].words.ROLE_SYSADMIN}</Typography>
                <FormControlLabel control={<Checkbox checked={isTestUser} onChange={() => setIsTestUser(!isTestUser)} />} label={`${resourceFinal[appLanguage].words.TEST} ${resourceFinal[appLanguage].words.USER}`} />
                <Typography variant="subtitle2" color="primary">{resourceFinal[appLanguage].words.ROLE_ADMIN}</Typography>
                <FormControlLabel control={<Checkbox checked={hasAdmin} onChange={() => setHasAdmin(!hasAdmin)} />} label={`${resourceFinal[appLanguage].words.ROLE_ADMIN}`} />
                <FormControlLabel control={<Checkbox checked={hasSysadmin} onChange={() => setHasSysadmin(!hasSysadmin)} />} label={`${resourceFinal[appLanguage].words.ROLE_SYSADMIN}`} />
            </Stack>
        );
    };

    const TableFragment = () => {
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(10);

        const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - employees.data?.filter(handleFilterResult).length) : 0;

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };

        const handleEditClick = (item) => {
            setOpenEdit(true);
            setSelectedEmployee(item);
        };

        const handleLinkClick = (item) => {
            setOpenLink(true);
            setSelectedEmployee(item);
        };

        return (
            <>
                <TableBody>
                    {(rowsPerPage > 0 ? employees.data?.filter(handleFilterResult).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : employees.data?.filter(handleFilterResult)).map(item =>
                        <TableRow key={item.id} sx={{ '&:nth-of-type(odd)': { bgcolor: 'white.main' }, height: 63 }}>
                            <TableCell align="center">{item.number}</TableCell>
                            <TableCell align="left">{item.fullname}</TableCell>
                            {hasActivities && <TableCell align="center"><Checkbox disabled checked={item.activities} /></TableCell>}
                            {hasTimetables && <TableCell align="center"><Checkbox disabled checked={item.timetables} /></TableCell>}
                            {hasEmployees && <TableCell align="center"><Checkbox disabled checked={item.employees} /></TableCell>}
                            {hasOrganisation && <TableCell align="center"><Checkbox disabled checked={item.organisation} /></TableCell>}
                            {hasPrograms && <TableCell align="center"><Checkbox disabled checked={item.programs} /></TableCell>}
                            {hasWebmaster && <TableCell align="center"><Checkbox disabled checked={item.webmaster} /></TableCell>}

                            {hasSubscriptions && <TableCell align="center"><Checkbox disabled checked={item.subscriptions} /></TableCell>}
                            {hasMessages && <TableCell align="center"><Checkbox disabled checked={item.messages} /></TableCell>}
                            {hasPlanning && <TableCell align="center"><Checkbox disabled checked={item.planning} /></TableCell>}
                            {hasAttendances && <TableCell align="center"><Checkbox disabled checked={item.attendances} /></TableCell>}
                            {hasReports && <TableCell align="center"><Checkbox disabled checked={item.reports} /></TableCell>}
                            {hasStudents && <TableCell align="center"><Checkbox disabled checked={item.students} /></TableCell>}
                            {hasSupervisor && <TableCell align="center"><Checkbox disabled checked={item.supervisor} /></TableCell>}

                            {isContact && <TableCell align="center"><Checkbox disabled checked={item.contactPerson} /></TableCell>}
                            {hasSysadmin && <TableCell align="center"><Checkbox disabled checked={item.sysadmin} /></TableCell>}
                            <TableCell align="center"><IconButton onClick={() => handleEditClick(item)}><EditIcon color="secondary" /></IconButton></TableCell>
                            {aspNetUser?.role?.includes("Sysadmin") && <TableCell align="center"><IconButton color="secondary" disabled={!item?.hasAspNetUser} onClick={() => handleLinkClick(item)}><LinkIcon /></IconButton></TableCell>}
                        </TableRow>
                    )}
                    {(rowsPerPage > 0 ? employees.data?.filter(handleFilterResult).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : employees.data?.filter(handleFilterResult)).length === 0 && <TableRow><TableCell colSpan={12}>{resourceFinal[appLanguage].messages.FILTER_RESULT_EMPTY}</TableCell></TableRow>}
                    {emptyRows > 0 && (
                        <TableRow style={{ height: 63 * emptyRows }}>
                            <TableCell colSpan={12} />
                        </TableRow>)}
                </TableBody >
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            sx={{ border: 0 }}
                            rowsPerPageOptions={[5, 10, 25,
                                {
                                    label: employees.data?.length < 100 ? resourceFinal[appLanguage].words.ALL : '100',
                                    value: employees.data?.length < 100 ? -1 : 100
                                }
                            ]}
                            count={employees.data?.filter(handleFilterResult)?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                            labelDisplayedRows={({ from, to, count }) => { return `${from}-${to} ${resourceFinal[appLanguage].messages.OF_THE} ${count}`; }}
                            labelRowsPerPage={resourceFinal[appLanguage].messages.TABLE_ROWS_PER_PAGE}
                        />
                    </TableRow>
                </TableFooter>
            </>
        );
    };

    return (
        <>
            <PageLayout
                title={resourceFinal[appLanguage].words.MANAGEMENT_EMPLOYEE}
                content={
                    <ContentLoader
                        successCondition={employees.status === "success"}
                        errorCondition={employees.status === "failed"}
                        content={
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center" sx={{ ...TableHeader, width: 120 }}>{resourceFinal[appLanguage].words.NUMBER}</TableCell>
                                            <TableCell align="left" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.NAME}</TableCell>
                                            {hasActivities && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_ACTIVITIES}</TableCell>}
                                            {hasTimetables && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_TIMETABLES}</TableCell>}
                                            {hasEmployees && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_EMPLOYEES}</TableCell>}
                                            {hasOrganisation && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_ORGANISATION}</TableCell>}
                                            {hasPrograms && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_PROGRAMS}</TableCell>}
                                            {hasWebmaster && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_WEBMASTER}</TableCell>}

                                            {hasSubscriptions && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_SUBSCRIPTIONS}</TableCell>}
                                            {hasMessages && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_MESSAGES}</TableCell>}
                                            {hasPlanning && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_PLANNING}</TableCell>}
                                            {hasAttendances && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_ATTENDANCES}</TableCell>}
                                            {hasReports && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_REPORTS}</TableCell>}
                                            {hasStudents && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_STUDENTS}</TableCell>}
                                            {hasSupervisor && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_SUPERVISOR}</TableCell>}

                                            {isContact && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.CONTACTPERSON}</TableCell>}
                                            {hasSysadmin && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}>{resourceFinal[appLanguage].words.ROLE_SYSADMIN}</TableCell>}
                                            <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}></TableCell>
                                            {aspNetUser?.role?.includes("Sysadmin") && <TableCell align="center" padding="checkbox" sx={{ ...TableHeader }}></TableCell>}
                                        </TableRow>
                                    </TableHead>
                                    <TableFragment />
                                </Table>
                            </TableContainer>
                        }
                    />
                } contentLeft={
                    <FilterSidebar enableSearch searchFilter={filter} searchFilterSet={setFilter} filters={<FilterFragment />} />
                } contentBottom={
                    <FilterButton filters={<FilterFragment />} />
                }
                bottomBar
                enableSearch
                searchFilter={filter}
                searchFilterSet={setFilter}
            />

            <Modal open={openEdit} onClose={callbackModalEdit}>
                <>
                    <EmployeeEditCard selectedEmployee={selectedEmployee} handleClose={callbackModalEdit} />
                </>
            </Modal>

            <Modal open={openLink} onClose={callbackModalLink}>
                <>
                    <EmployeeLinkCard selectedEmployee={selectedEmployee} handleClose={callbackModalLink} />
                </>
            </Modal>
        </>
    );
}
